// ./src/mixins/wakelock
export default {
  name: 'WakeLock',
  data () {
    return {
      wakeLockStatusFeedback: 'No Message',
      wakeLockSentinel: null,
      wakeLockActive: false,
      wakeLockBorderColor: 'border-yellow-300',
      wakeLockBorderOpacity: 'border-opacity-10'
    }
  },
  methods: {

    changeWakeLockUI (status = 'acquired') {
      const acquired = status === 'acquired'
      // this.$l.info('WakeLock mixin', 'changeWakeLockUI invoked, acquired =', acquired)
      // this.$refs.wakeLockBtn.dataset.status = acquired ? 'on' : 'off'
      // this.$refs.wakeLockBtn.textContent = `Turn Wake Lock ${acquired ? 'OFF' : 'ON'}`
      // this.wakeLockStatusFeedback = `Wake Lock ${acquired ? 'is active!' : 'has been released.'}`
      if (status === 'acquired') {
        this.wakeLockBorderColor = 'bg-green-600 bg-opacity-100'
      }
      else {
        this.wakeLockBorderColor = 'bg-yellow-600 bg-opacity-100'
      }
    },

    async requestWakeLock () {
      // this.$l.info('WakeLock mixin', 'requestWakeLock invoked')
      // create an async function to request a wake lock
      if ('wakeLock' in navigator) {
        try {
          this.wakeLockSentinel = await navigator.wakeLock.request('screen')
          this.changeWakeLockUI('acquired')

          // this.$l.success('WakeLock mixin', 'requestWakeLock active, wakeLockSentinel created:', this.wakeLockSentinel)

          // In case another tab was opened, regain wakelock, when visible again
          document.addEventListener('visibilitychange', this.reGainWakeLock)
        }
        catch (error) {
          this.$l.error('WakeLock mixin', 'requestWakeLock invoked; error', error.id + ': ' + error.message)
          // this.$refs.wakeLockBtn.dataset.status = 'off'
          // The Wake Lock request has failed - usually system related, such as battery.
          // this.wakeLockStatusFeedback = `${err.name}: ${err.message}`
          // this.wakeLockStatusFeedback = 'Turn Wake Lock ON'
        }
      }
      else {
        this.$l.error('WakeLock mixin', 'requestWakeLock', 'WakeLog not found in navigator')
      }
    }, // requestWakeLock ()

    releaseWakeLock () {
      // this.$l.info('WakeLock mixin', 'releaseWakeLock invoked')
      this.wakeLockSentinel.release()
        .then(() => {
          this.wakeLockSentinel = null
          // this.wakeLockStatusFeedback = 'Wake Lock has been successfully released!'
          this.changeWakeLockUI('released')
        })
    },

    async reGainWakeLock () {
      // this.$l.info('WakeLock mixin', 'reGainWakeLock invoked')
      if (this.wakeLockSentinel !== null && document.visibilityState === 'visible') {
        // this.$l.log('WakeLock mixin', 'reGainWakeLock', 'request navigator.wakeLock screen again...')
        this.wakeLockSentinel = await navigator.wakeLock.request('screen')
        // this.$l.debug('WakLock mixin', 'reGainwakeLock wakeLockSentinel =', this.wakeLockSentinel)
      }
      else {
        // this.$l.debug('WakeLock mixin', 'reGainWakeLock wakeLockSentinel =', this.wakeLockSentinel)
      }
    }

    // ----- WakeLock
    // checkWakeLockStatus () {
    //   if (this.wakeLockSentinel !== null) {
    //     this.wakeLockStatusFeedback = 'wakeLock is activated'
    //   }
    //   else {
    //     this.wakeLockStatusFeedback = 'WakeLock is not activated'
    //   }
    // },

    // checkWakeLockAvailability (e) {
    //   this.log = 'checkWakeLockAvailability invoked'
    //   if (this.$refs.wakeLockBtn.dataset.status === 'off') {
    //     this.requestWakeLock()
    //   }
    //   else {
    //     this.releaseWakeLock()
    //   }
    // },
  }
}
